import { db } from '../../config/Fire';
import * as Constants from './../../constants/nodes_database';

export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const SAVING_SERVICES = 'SAVING_SERVICES';
export const SAVED_SERVICES = 'SAVED_SERVICES';

const setServiceRemoved = payload => ({ type: REMOVE_SERVICE, payload });
export const setSavingServices = payload => ({ type: SAVING_SERVICES, payload });
export const setSavedServices = payload => ({ type: SAVED_SERVICES, payload });

export const removeServiceAdmin = payload => {
    return dispatch => {
        var isSavingServices = true;
        dispatch(setSavingServices(isSavingServices));
        const { key, services } = payload;
        var myRef = db.ref(`${Constants.SERVICES}/${key}`);
        return myRef.remove()
        .then(() => {
            //console.log("getRestaurant: " + JSON.stringify(restaurant));
            delete services[key];
            dispatch(setServiceRemoved(services));
            dispatch(setSavingServices(isSavingServices = false));
            var isSavedServices = true;
            dispatch(setSavedServices(isSavedServices));
        })
        .catch(err => {
            console.log("not found save data " + err);
            dispatch(setSavingServices(isSavingServices = false));
        });
    };
};